export const FB = {
  viewContent: function () {
    if (typeof window.fbq !== 'undefined') {
      const params = {};
      window.fbq('track', 'ViewContent', params);
      window.gtag('event', 'ViewContent', params);
    } else {
      console.log('no fbq defined');
    }
  },
  initiateCheckout: function () {
    if (typeof window.fbq !== 'undefined') {
      const params = {};
      window.fbq('track', 'InitiateCheckout', params);
      window.gtag('event', 'begin_checkout', params);
    } else {
      console.log('no fbq defined');
    }
  },
  lead: function () {
    if (typeof window.fbq !== 'undefined') {
      const params = {};
      window.fbq('track', 'Lead', params);
      window.gtag('event', 'Lead', params);
    } else {
      console.log('no fbq defined');
    }
  },
};
